import { css } from "styled-components/macro";

import {
  borderRadius,
  colors,
  fontSize,
  fontStyle,
  space,
} from "shared/styles/constants";
import { hoverFocus } from "shared/styles/defaults";
import styled from "styled-components";

export interface ActionContainerProps {
  hideContainer?: boolean;
  isActive?: boolean;
  size?: "s" | "m";
}

export const ActionContainer = styled.button<ActionContainerProps>`
  width: fit-content;
  display: flex;
  align-items: center;

  color: ${({ isActive }) => (isActive ? colors.black : colors.white)};
  ${fontSize.xs}
  ${fontStyle.bold}

  min-height: 32px;

  ${({ size }) => {
    switch (size) {
      case "m":
        return css`
          padding: calc(${space.xs} - 2px) ${space.m};
          ${fontSize.s}
        `;
    }
  }}

  ${hoverFocus.defaultFocus};

  ${({ hideContainer, isActive }) =>
    !hideContainer &&
    css`
      border: 1px solid ${colors.grey2};
      border-radius: ${borderRadius.s};

      background-color: ${isActive ? colors.white : colors.grey1};

      ${!isActive && hoverFocus.defaultHover(colors.grey3)};
    `}

  ${({ hideContainer }) =>
    !hideContainer &&
    css`
      > * {
        padding: calc(${space.xxs} + 1px) ${space.s} calc(${space.xxs} + 2px);
      }
    `}

  span {
    text-align: start;
  }

  svg {
    flex: 0 0 auto;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;
